module.exports = __webpack_public_path__ + "img/rocket.ba074d48.svg";